import _ from "lodash";
import React from "react";
import { labelColor } from "../../utils/color";

const QuantityBoxStyle = (color) => ({
  width: 32,
  height: 32,
  color: labelColor(color.hex),
  backgroundColor: color.hex,
  marginRight: 8,
  marginBottom: 8,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: 12,
  border: "1px solid grey",
});

const QuantityBox = ({ data, color }) => {
  const value = Object.values(data).reduce(
    (total, current) => total + current,
    0,
  );

  return (
    <div className="quantities" style={QuantityBoxStyle(color)}>
      {value}
    </div>
  );
};

export const QuantitiesBox = ({ data, colors }) => {
  return colors.map((c, index) => {
    const code = c.code;
    if (!_.get(data, code)) {
      return (
        <div key={code + String(index)} style={QuantityBoxStyle(c)}>
          {0}
        </div>
      );
    }

    return (
      <QuantityBox key={code + String(index)} data={data[code]} color={c} />
    );
  });
};

export default QuantitiesBox;
